import { jsxs, jsx } from "react/jsx-runtime";
import IconCheck from "./assets/IconCheck.js";
import useThemePresetClasses from "../../../hooks/useThemePresetClasses.js";
import { cn } from "../../../utils/cn.js";
const Checkbox = ({ classes, className, variant = "outlined", size = "md", ...inputProps }) => {
  const { themeClasses } = useThemePresetClasses("Checkbox", classes, className, {
    variant,
    modifier: size
  });
  return /* @__PURE__ */ jsxs("div", { className: cn("relative transition-colors", themeClasses == null ? void 0 : themeClasses.root), children: [
    /* @__PURE__ */ jsx(
      "input",
      {
        type: "checkbox",
        className: cn("peer/checkbox", themeClasses == null ? void 0 : themeClasses.input),
        ...inputProps
      }
    ),
    /* @__PURE__ */ jsx(
      IconCheck,
      {
        className: cn(
          "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 opacity-0 transition-opacity peer-checked/checkbox:opacity-90",
          themeClasses == null ? void 0 : themeClasses.symbol
        )
      }
    )
  ] });
};
const Checkbox$1 = Checkbox;
export {
  Checkbox$1 as default
};
